var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveClosed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.381 9.58335V12.9167C18.381 15.8334 16.71 17.0834 14.2034 17.0834H5.84841C3.3419 17.0834 1.6709 15.8334 1.6709 12.9167V7.08335C1.6709 4.16669 3.3419 2.91669 5.84841 2.91669H10.0259",
    stroke: "#264254",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84863 7.5L8.46376 9.58333C9.32433 10.2667 10.7363 10.2667 11.5969 9.58333",
    stroke: "#264254",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2756 2.35001L16.5096 2.82501C16.6265 3.05834 16.919 3.27501 17.178 3.32501L17.4955 3.37501C18.4479 3.53334 18.6735 4.23334 17.9884 4.92501L17.696 5.21667C17.5038 5.41667 17.3952 5.80001 17.4537 6.06667L17.4955 6.24168C17.7545 7.39168 17.1446 7.83333 16.142 7.23333L15.9247 7.10834C15.6657 6.95834 15.248 6.95834 14.989 7.10834L14.7717 7.23333C13.7608 7.84167 13.1508 7.39168 13.4182 6.24168L13.46 6.06667C13.5185 5.80001 13.4099 5.41667 13.2177 5.21667L12.9253 4.92501C12.2401 4.23334 12.4657 3.53334 13.4182 3.37501L13.7357 3.32501C13.9864 3.28334 14.2871 3.05834 14.4041 2.82501L14.638 2.35001C15.0892 1.44168 15.8245 1.44168 16.2756 2.35001Z",
    stroke: "#264254",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveClosed);
export default __webpack_public_path__ + "static/media/ActiveClosed.f841fed0b9adb42e4979915ac9d486e2.svg";
export { ForwardRef as ReactComponent };